<ng-template #content let-modal>
  <div class="special-offer">
    <div class="modal-header">
      <!--    <p class="modal-title" id="modal-basic-title">Special offer ends now!</p>-->
      <a type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <img aria-hidden="true" src="assets/images/icons/cancel.png" width="12"/>
      </a>
    </div>
    <div class="modal-body text-center" *ngIf="(specialOfferState | async).actualOffer !== null">
      <h2 class="text-uppercase mb-2">Special offer</h2>
      <p class="mb-3">
        You'll only see this offer once!
      </p>
      <app-countdown [startCounter]="countTimeDistance()"></app-countdown>
      <div class="offer">
        <p>for only</p>
        <h4 class="font-weight-light line-through mt-1">{{(specialOfferState | async).actualOffer.regular_amount | number:'1.2-2'}}$</h4>
        <h1 class="text-info">{{(specialOfferState | async).actualOffer.amount | number:'1.2-2'}}$</h1>
        <p class="my-2">extra you will get:</p>
        <ul class="blue-list">
          <li
            *ngIf="(specialOfferState | async).actualOffer.permissions['auditor.limit'] !== undefined
                  && (specialOfferState | async).actualOffer.permissions['auditor.limit'].periodic == 1
                "
          >
            {{(specialOfferState | async).actualOffer.permissions['auditor.limit'].periodic_count}}
            month
            <span *ngIf="(specialOfferState | async).actualOffer.permissions['auditor.limit'].periodic_count > 1">s</span>
            of access with regular data updates
          </li>
          <li>Quality certification your profile</li>
          <li>Access to special webinars and trainings</li>
        </ul>
      </div>
    </div>
    <div class="modal-footer text-center py-3">
      <button type="button" class="btn btn-white btn-lg mx-auto" *ngIf="countTimeDistance() > 0" (click)="onUseSpecialOffer()">Get it now</button>
    </div>
  </div>

</ng-template>
